const Milhouse = {
  level1: '#E3F1F8',
  Mi100: '#E3F1F8',
  level2: '#BBDCEF',
  Mi200: '#BBDCEF',
  level3: '#93C6E4',
  Mi300: '#93C6E4',
  level4: '#6DAFD9',
  Mi400: '#6DAFD9',
  level5: '#2C91D1',
  Mi500: '#2C91D1',
  level6: '#2284C4',
  Mi600: '#2284C4',
};

export { Milhouse };
